import Marquee from "react-fast-marquee";
import { Music } from "lucide-react";

const ITEMS = [
  "Conservatoire de la Musique Chrétienne",
  "Masterclass Piano Gospel Gratuite",
  "Samedi 10 octobre — 19h",
  "Bruxelles · Woluwe-Saint-Lambert",
];

export default function MarqueeRibbon() {
  return (
    <div data-testid="editorial-marquee" className="bg-[#F0A202] border-y border-[#2C1E16]/10 py-4 -rotate-1 scale-[1.02] my-[-8px] relative z-20">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span
            key={item}
            className="mx-8 flex items-center gap-8 text-[#2C1E16] uppercase tracking-[0.2em] text-sm font-extrabold whitespace-nowrap"
          >
            {item}
            <Music className="w-4 h-4" />
          </span>
        ))}
      </Marquee>
    </div>
  );
}
